import styled from '@emotion/styled';
import { AppBar, Hidden, IconButton, Toolbar, withStyles } from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import { ClassAttributes, createElement, MouseEventHandler, useContext } from 'react';

import Language from '../../../../entity/Language';
import Organization from '../../../../entity/Organization';
import User from '../../../../entity/User';
import mq from '../../../../view/styleUtility/mediaquery';
import { COLOR_SECONDARY_BUTTON_BACKGROUND_MAIN, COLOR_TEXT_MAIN } from '../../../constant/color';
import { SPACING_UNIT } from '../../../constant/spacing';
import { context as DependencyContext } from '../../../context/dependency';
import KaizenLogo from '../../primitive/Icons/KaizenLogo';
import KaizenLogoOnly from '../../primitive/Icons/KaizenLogoOnly';
import OrganizationsSelect from '../OrganizationsSelect';
import CommonMenu from './CommonMenu';
import UserMenu from './UserMenu';

export const HEADBAR_HEIGHT = 72;

interface Props {
  signedInUser: User;
  onClickSignOut: MouseEventHandler<HTMLElement>;
  profileWebUrl: string;
  className?: string;
  triggerDrawer: () => void;
  organizations: Organization[] | null;
  onSubmit: (lang: Language) => void;
  currentOrgOrAccount: Organization | null;
  setCurrentOrgOrAccount: (organization: Organization) => void;
  drawerOpen?: boolean;
  limited?: boolean;
}

const HeadBar = ({
  signedInUser,
  onClickSignOut,
  className,
  triggerDrawer,
  profileWebUrl,
  organizations,
  currentOrgOrAccount,
  setCurrentOrgOrAccount,
  drawerOpen,
  limited = false,
}: ClassAttributes<HTMLElement> & Props) => {
  const dependency = useContext(DependencyContext);
  return (
    <StyledAppBar color="default" elevation={2} className={className}>
      <Hidden mdUp>
        <StyledToolbar>
          <div style={{ width: 104 }}>
            {!limited && (
              <StyledIconButton onClick={() => triggerDrawer()}>
                {!drawerOpen ? (
                  <Menu style={{ color: COLOR_SECONDARY_BUTTON_BACKGROUND_MAIN }} />
                ) : (
                  <CloseIcon style={{ color: COLOR_SECONDARY_BUTTON_BACKGROUND_MAIN }} />
                )}
              </StyledIconButton>
            )}
          </div>
          <KaizenLogoOnly />
          <div style={{ display: 'flex', width: 104, justifyContent: 'flex-end' }}>
            {!limited && (
              <CommonMenu
                organizations={organizations}
                currentOrgOrAccount={currentOrgOrAccount}
                setCurrentOrgOrAccount={setCurrentOrgOrAccount}
              />
            )}
            <UserMenu
              signedInUser={signedInUser}
              onClickSignOut={onClickSignOut}
              currentLang={signedInUser.lang}
              profileWebUrl={profileWebUrl}
              onSubmit={(lang: Language) => dependency.userUsecase.updateUserLang(lang)}
              isSmartPhone={true}
              hideProfile={limited}
            />
          </div>
        </StyledToolbar>
      </Hidden>
      <Hidden smDown>
        <StyledToolbar>
          <TextContainer>
            <KaizenLogo />
          </TextContainer>
          <SettingContainer>
            {/* <LangMenu
            currentLang={signedInUser.lang}
            onSubmit={(lang: Language) => dependency.userUsecase.updateUserLang(lang)}
          /> */}
            {!limited &&
            organizations &&
            organizations.length > 0 &&
            location.pathname.indexOf('invitation_agent') === -1 ? (
              <OrganizationsSelect
                currentOrganizationId={currentOrgOrAccount ? currentOrgOrAccount.id : null}
                organizations={organizations}
                onChangeCurrentOrganization={(organization: Organization) => {
                  setCurrentOrgOrAccount(organization);
                }}
                isSmartPhone={false}
              />
            ) : null}
            <UserMenu
              signedInUser={signedInUser}
              onClickSignOut={onClickSignOut}
              currentLang={signedInUser.lang}
              profileWebUrl={profileWebUrl}
              onSubmit={(lang: Language) => dependency.userUsecase.updateUserLang(lang)}
              isSmartPhone={false}
              hideProfile={limited}
            />
          </SettingContainer>
        </StyledToolbar>
      </Hidden>
    </StyledAppBar>
  );
};

const StyledAppBar = withStyles({
  root: {
    zIndex: 1300,
    backgroundColor: COLOR_TEXT_MAIN,
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    height: 64,
  },
})(AppBar);

const StyledToolbar = styled(Toolbar)([
  {
    height: HEADBAR_HEIGHT,
    minHeight: HEADBAR_HEIGHT,
    // borderBottom: `1px solid ${theme.palette.grey['200']}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  {
    '@media (min-width: 1024px)': {
      height: HEADBAR_HEIGHT,
      minHeight: HEADBAR_HEIGHT,
      // marginLeft: MENU_WIDTH,
      // borderBottom: `1px solid ${theme.palette.grey['200']}`,
    },
  },
]);

const TextContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

const StyledIconButton = styled(IconButton)({
  marginRight: SPACING_UNIT,
  color: COLOR_SECONDARY_BUTTON_BACKGROUND_MAIN,
  [mq('sp')]: {
    marginRight: SPACING_UNIT / 4,
    padding: SPACING_UNIT / 4,
  },
}) as typeof IconButton;

const SettingContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  marginLeft: 'auto',
});

export default HeadBar;
